// src/mediator/Mediator.js

export class Mediator {
    #channels = {};
    #wildcardSubscribers = [];

    /**
     * Abonniere ein spezifisches Event
     * @param {string} eventName - z.B. 'map:marker:hover'
     * @param {function} callback - Reaktion auf das Event
     */
    subscribe(eventName, callback) {
        if (!this.#channels[eventName]) {
            this.#channels[eventName] = [];
        }
        this.#channels[eventName].push(callback);
    }

    /**
     * Veröffentliche ein Event an alle Listener
     * @param {string} eventName
     * @param {*} payload
     */
    publish(eventName, payload) {
        if (this.#channels[eventName]) {
            this.#channels[eventName].forEach(fn => fn(payload));
        }

        // Zusätzlich: Wildcard-Listener (auch mitten im String erlaubt)
        this.#wildcardSubscribers.forEach(({ pattern, callback }) => {
            if (pattern.test(eventName)) {
                callback(eventName, payload);
            }
        });
    }

    /**
     *     * Abonniere Eventgruppen mit Wildcard (z.B. 'map:*', '*:hover', 'map:*:hover')
     *      * Unterstützt Wildcards an beliebiger Stelle (z.B. 'marker:*:mouseover')
     *      * @param {string} wildcardPattern - z.B. 'map:*', '*:hover', 'map:*:hover'
     *      * @param {function} callback - wird mit (eventName, payload) aufgerufen
     *      * @param {string} [origin] - optionaler Ursprung für Debugging/Analyse
     *      */
    subscribeWildcard(wildcardPattern, callback, origin = undefined) {
        // Ersetze '*' durch '.*' (inkl. erlaubter Zwischenstellen)
        const escaped = wildcardPattern.split('*').map(this.#escapeRegex).join('.*');
        const regex = new RegExp('^' + escaped + '$');
        this.#wildcardSubscribers.push({ pattern: regex, callback, origin });
    }

    /**
     * Hilfsfunktion zur Regex-Sicherheit für Wildcard-Musterteile
     * @param {string} str
     * @returns {string}
     */
    #escapeRegex(str) {
        return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }

    /**
     * Semantisches Alias für Debug-Watcher
     * @param {string} wildcardPattern
     * @param {function} callback
     */
    watchOnly(wildcardPattern, callback) {
        this.subscribeWildcard(wildcardPattern, callback, 'debug');
    }

    /**
     * Zugriff auf alle aktiven Wildcard-Subscriber (z.B. für UI-Zwecke)
     * @param {object} [filter] - z.B. { origin: 'debug' }
     */
    listSubscribers(filter = {}) {
        return this.#wildcardSubscribers.filter(s => {
            return Object.entries(filter).every(([key, val]) => s[key] === val);
        });
    }
}
